module.exports = __webpack_public_path__ + "img/lishijilu.8c3abfbe.png";